import React, { useEffect } from 'react';
import { Icon, Header, Button, Divider, Tab } from 'semantic-ui-react';
import history from 'services/history';
import Table from './Table';
import { DateTime } from 'luxon';
// import { useSubscription } from 'utils';
// import request from 'services/http';
// import { finalize, tap } from 'rxjs/operators';
// import { toast } from 'react-toastify';

export default function TabelaPedidos(props) {
    // const [, setIsSubmitting] = useState(false);
    // const [dados, setDados] = useState([]);

    useEffect(() => {
        const idPedido = new URL(window.location).searchParams.get('id-pedido');
        const idProcesso = new URL(window.location).searchParams.get('id-processo');
        if (idPedido || idProcesso) {
            console.log(idPedido, idProcesso);
        }
    }, [props.location.search]);

    //GET RELATORIO
    // const submitRelatorio$ = useMemo(
    //     () =>
    //         request({
    //             url: `/validfisco/dashboard/pedidoID${props.location.search}`,
    //             method: 'GET',
    //         }).pipe(
    //             tap(({ response }) => {
    //                 if (response.data.length <= 0) {
    //                     toast.error('Dados não encontrados.');
    //                     return;
    //                 } else {
    //                     setDados(response.data);
    //                     console.log(dados);
    //                 }
    //             }),
    //             finalize(() => setIsSubmitting(false)),
    //         ),
    //     [props.location.search],
    // );
    // useSubscription(submitRelatorio$, props.location.search);

    const columns = [
        {
            name: 'id',
            title: '#',
            render: (value) => <a href="#so-bad">{value}</a>,
        },
        {
            name: 'name',
            title: 'Name',
            render: (value) => <p style={{ color: 'red' }}>{value}</p>,
        },
        {
            name: 'description',
            title: 'Description',
            render: (value) => value.slice(0, 15) + '...',
        },
        {
            name: 'description',
            title: 'Description',
            render: (value) => value.slice(0, 15) + '...',
        },
        {
            name: 'description',
            title: 'Description',
            render: (value) => value.slice(0, 15) + '...',
        },
        {
            name: 'date',
            title: 'Date',
            render: (value) =>
                value
                    ? DateTime.fromFormat(value.toString(), 'yyyyMMddHHmmss').toFormat('dd/MM/yyyy')
                    : '',
        },
    ];

    const panes = [
        {
            menuItem: { key: 'users', icon: 'users', content: 'Users' },
            render: () => <Tab.Pane>Tab 1 Content</Tab.Pane>,
        },
        {
            menuItem: { key: 'users', icon: 'lock', content: 'Documents' },
            render: () => <Tab.Pane>Tab 2 Content</Tab.Pane>,
        },
        {
            menuItem: { key: 'users', icon: 'file powerpoint outline', content: 'Documents' },
            render: () => <Tab.Pane>Tab 2 Content</Tab.Pane>,
        },
        {
            menuItem: { key: 'users', icon: 'blind', content: 'Documents' },
            render: () => <Tab.Pane>Tab 2 Content</Tab.Pane>,
        },
        {
            menuItem: { key: 'users', icon: 'hand pointer outline', content: 'Documents' },
            render: () => <Tab.Pane>Tab 2 Content</Tab.Pane>,
        },
    ];

    const data = [
        {
            id: <Icon name="angle down" />,
            name: 'Joe',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, amet.',
            _content: () => (
                <div style={{ padding: 25 }}>
                    <Tab panes={panes} />
                </div>
            ),
            date: 20200101000000,
        },
        {
            id: 2,
            name: 'John',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, amet.',
            date: 20200107000000,
            _content: () => (
                <div style={{ padding: 25 }}>
                    <Tab panes={panes} />
                </div>
            ),
        },
        {
            id: 3,
            name: 'Daniel',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, amet.',
            date: 20200103000000,
            _content: () => (
                <div style={{ padding: 25 }}>
                    <Tab panes={panes} />
                </div>
            ),
        },
        {
            id: 4,
            name: 'Daniel',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, amet.',
            date: 20200103000000,
            _content: () => (
                <div style={{ padding: 25 }}>
                    <Tab panes={panes} />
                </div>
            ),
        },
        {
            id: 5,
            name: 'Daniel',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, amet.',
            date: 20200103000000,
            _content: () => (
                <p style={{ color: 'green' }}>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                </p>
            ),
        },
        {
            id: 6,
            name: 'Daniel',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, amet.',
            date: 20200103000000,
            _content: () => (
                <p style={{ color: 'green' }}>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                </p>
            ),
        },
        {
            id: 7,
            name: 'Daniel',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, amet.',
            date: 20200103000000,
            _content: () => (
                <p style={{ color: 'green' }}>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                </p>
            ),
        },
        {
            id: 8,
            name: 'Daniel',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, amet.',
            date: 20200103000000,
        },
    ];

    return (
        <div id="combustiveis-valid-fisco" className="row flex-grow-1 mt-2">
            <div className="col d-flex flex-column">
                <div className="row mx-0">
                    <div className="col px-0">
                        <Header as="h3">
                            <Icon.Group size="big">
                                <Icon name="ordered list" className="primary-color" />
                            </Icon.Group>
                            <Header.Content className="primary-color">
                                Pedidos <Header.Subheader>Relatório</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>
                    <div className="col-12 col-md-2 d-print-none px-0">
                        <Button
                            icon
                            labelPosition="left"
                            size="tiny"
                            color="orange"
                            floated="right"
                            onClick={() => history.goBack()}
                        >
                            <Icon name="arrow left" />
                            Voltar
                        </Button>
                    </div>
                </div>
                <Divider className="mt-2 mb-2 custom-divider darken" fitted />

                <div className="row mx-0">
                    <div className="col px-0">
                        <Table
                            columns={columns}
                            celled
                            data={data}
                            config={{ theme: 'semantic-ui' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
